import { getMenuAuth } from "src/apis/authApi";
import {  useCallback, useEffect } from "react";
import {  getPUR2020_R01List, getPUR2020_R01AllCount, exportPUR2020_R01Excel } from "./Api_PUR2020_R01"
import useActionbarAuthStore from "src/store/useActionbarAuthStore";
import useMenuGlobalStore from "src/store/useMenuStore";
import { downloadSettingExcel } from "src/utils/blob/blobUtil";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";

import { usePUR2020_R01Store, defaultPUR2020_R01Filter, PUR2020_R01Filter } from "./Store_PUR2020_R01";
import { PUR2020_R01Dto } from "./Dto_PUR2020_R01";
import { fetchDataSetHandler, fetchFilterConfig } from "src/utils/grid/GridHandlerContent";

interface ProductResultContentProps {
    setMessage: (message: string) => void;
}

export const Content_PUR2020_R01 = (props: ProductResultContentProps) => {
    const { setMessage } = props;

    const { 
        PUR2020_R01Filter, setPUR2020_R01Filter,
        PUR2020_R01PastFilter, setPUR2020_R01PastFilter,
        PUR2020_R01List, setPUR2020_R01List, 
        setAllCount,
        setScrollTop,
    } = usePUR2020_R01Store();
    const { setLoadingSpinner } = useLoadingSpinnerStore();
    const { selectedThirdMenu } = useMenuGlobalStore();
    const menuCdStore = selectedThirdMenu?.menuCd;
    const setAuth = useActionbarAuthStore((state) => state.setAuth);

    useFetchActionbarAuth("PUR2020_R01");

    useEffect(() => {
        getMenuAuth("PUR2020_R01").then((res) => {
            setAuth(res.data);
        });
    }, []);


    const getParams = (filter: Partial<PUR2020_R01Filter>) => {
        return {
            compCd: filter.compCd,
            transportDt: filter.transportDt,
            logicCenter: filter.logicCenter,
            workplaceCd: filter.workplaceCd,
            itemCd: filter.itemCd,
            brandCd: filter.brandCd,
            customCd: filter.customCd,
            itemGroup: filter.itemGroup,
            inoutClass: filter.inoutClass,
        };
    }

    const renewalAllCount = useCallback(async () => {
        const response = await getPUR2020_R01AllCount(getParams(PUR2020_R01Filter));
        setAllCount(response.data.data);
        return response.data.data;
    }, [PUR2020_R01Filter, setAllCount]);

    const fetchData = useCallback(async () => {
        setScrollTop(null);
        setLoadingSpinner(true);
        try {
			
            const response = await getPUR2020_R01List(
                '',
                getParams(PUR2020_R01Filter),
                PUR2020_R01List.length ?? 0
            );

            const rawData = (response.data.data as Omit<PUR2020_R01Dto, 'valueIndex'|'orderIndex'|'orderIndexSeq'>[]).map((row, idx) => ({
                valueIndex: idx,
                orderIndex: idx + 1,
                orderIndexSeq: 0,
                ...row,
            }));

			const newList = [...rawData ] as PUR2020_R01Dto[];
            const processAllCount = await renewalAllCount();

            if (newList && newList.length > 0) {
                setPUR2020_R01PastFilter(PUR2020_R01Filter);
                setPUR2020_R01List(newList);
                ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
            } else {
                showWarning('데이터가 없습니다.');
                setPUR2020_R01List([]);
            }
        } catch (error) {
            console.error('데이터 조회 실패:', error);
            showWarning('데이터 조회에 실패했습니다.');
            setPUR2020_R01List([]);
        } finally {
            setLoadingSpinner(false);
        }
    }, [PUR2020_R01Filter, setPUR2020_R01List, setPUR2020_R01PastFilter, setScrollTop]);
    
    const handleExcelClick = async () => {
        const {isDefaultFilter, isDefaultPastFilter, listLength} = fetchFilterConfig(
            PUR2020_R01Filter,
            PUR2020_R01PastFilter,
            defaultPUR2020_R01Filter,
            PUR2020_R01List.length
        );

        const response = await exportPUR2020_R01Excel(
            isDefaultFilter? '' : 'search',
            getParams(PUR2020_R01Filter),
            listLength
        );
        downloadSettingExcel({
            responseData: response.data.data,
            fileName: '입고현황 조회-excel.xlsx',
        });
    };

    return {
        fetchData,
        handleExcelClick,
    };
};


